import { AxiosInstance } from "axios"
import { ChatRequest, ChatResponse, WarrenStreamEvent } from "../views/pages/Warren/types"
import { parseNDJSON } from "../utils/ndjson"

export interface IWarrenApi {
  query: (request: ChatRequest) => Promise<ChatResponse>
  streamQuery: (request: ChatRequest, signal?: AbortSignal) => AsyncGenerator<WarrenStreamEvent>
}

/**
 * Api routes for /api/v1/warren/
 */
const warren = (axiosClient: AxiosInstance): IWarrenApi => ({
  query: async (request: ChatRequest) => {
    const { data } = await axiosClient.post<ChatResponse>("/warren/chat/", request)
    return data
  },

  streamQuery: async function* (
    request: ChatRequest,
    signal?: AbortSignal,
  ): AsyncGenerator<WarrenStreamEvent> {
    const baseURL = axiosClient.defaults.baseURL || ""
    const authHeader = axiosClient.defaults.headers.common["Authorization"]

    const response = await fetch(`${baseURL}warren/chat/stream`, {
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/x-ndjson",
        ...(authHeader ? { Authorization: authHeader as string } : {}),
      },
      body: JSON.stringify(request),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    if (!response.body) {
      throw new Error("Response body is null")
    }

    // Use the NDJSON parser to yield events as they arrive
    yield* parseNDJSON<WarrenStreamEvent>(response.body)
  },
})

export default warren
